import { render, staticRenderFns } from "./FilesView.vue?vue&type=template&id=0b0215f0"
import script from "./FilesView.vue?vue&type=script&lang=js"
export * from "./FilesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/FilesView.vue
// module id = 2102
// module chunks = 31